var React = require('react');

function Home (props) {
    return React.createElement("svg",props,React.createElement("g",{"strokeLinecap":"round","strokeLinejoin":"bevel"},[React.createElement("path",{"d":"M 47.70455932617188 47 L 3.295438766479492 47 L 25.5 4.332411766052246 L 47.70455932617188 47 Z","stroke":"none","key":0}),React.createElement("path",{"d":"M 25.5 8.664794921875 L 6.590862274169922 45 L 44.40913772583008 45 L 25.5 8.664794921875 M 25.5 0 L 51 49 L 0 49 L 25.5 0 Z","stroke":"none","key":1})]));
}

Home.defaultProps = {"width":"51","height":"49","viewBox":"0 0 51 49"};

module.exports = Home;

Home.default = Home;
